const { id, log, delay } = require("../std/index")


//
// Gallery Swapper
//
// Basic fadeshow
//

module.exports = class GallerySwapper {
  constructor($host, config) {
    this.activeClass = 'is-active';
    this.fadeTime = 500;

    this.dom = {
      main: $host,
      slides: $('[data-slide-ix]', $host)
    };

    this.current = 0;
  }

  set(ix) {
    this.dom.slides.removeClass(this.activeClass).eq(ix).addClass(this.activeClass);
    this.current = ix;
  }

  next() {
    const target = this.current + 1 < this.dom.slides.length ? this.current + 1 : 0;
    this.set(target);
  }

  length() {
    return this.dom.slides.length;
  }
};
